import axios from "axios";
import VueCookies from "vue-cookies";
import { store } from "../src/store";

const admin = VueCookies.get("admin");
const token = admin ? admin.token : "";
const domain = process.env.VUE_APP_DOMAIN;
const api = axios.create({
  baseURL: process.env.VUE_APP_RNPL_URL,
  headers: {
    Authorization: `Bearer ${token}`, //add access token,
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
//not compulsory but nice to have
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      if ((domain = "localhost")) {
        VueCookies.remove("admin", "/", "localhost");
        window.location = "/";
      } else {
        VueCookies.remove("admin", "/", `.${domain}`);
        window.location = "/";
      }
    }

    if (
      error.config.method === "get" &&
      error.response &&
      error.response.status === 403
    ) {
      store.commit("auth/unauthorised", true);
    }

    /** Handle errors **/
    return Promise.reject(error);
  }
);

api.interceptors.request.use(config => {
  store.commit("auth/unauthorised", false);
  return config;
});

export default api;



//////////////////
// WEBPACK FOOTER
// ./services/rnplService.js
// module id = null
// module chunks = 